import {
    Box, Typography
} from '@mui/material'

import Tile from '@components/Tile'
import Alert from "@components/Alert";

export const Maintenance = () => {
    return (
        <Tile sx={{p: 0}}>
            <Box sx={{p: 2, pb: 0}}>
                <Typography variant={'h2'}>Firewall migration</Typography>
                <Alert severity={'warning'} title={'Maintenance'} icon={'build'} sx={{mt: 2, mb: 2}}>
                    <Typography variant={'body2'} sx={{mt: 1}}>The Landing-Zones migration process is in maintenance.</Typography>
                    <Typography variant={'body2'}>Please come back in few hours.</Typography>
                </Alert>
            </Box>
        </Tile>
    )
}

export default Maintenance